import { authConstants } from './../constants/auth-constants';
import  ConfigurationService  from './../services//configuration-service'

export const addAgentLimit = (data) => async (dispatch) => {
    try {
      const res = await ConfigurationService.addAgentLimit(data);
      dispatch({
        type: authConstants.ADD_AGENT_LIMIT,
        payload: res.data,
      });
      return Promise.resolve(res.data);
    } catch (err) {
      return Promise.reject(err);
    }
  };